import React, { useState } from 'react';
import { isBlank, isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import BidPresenter from 'presenters/BidPresenter';
import LoanOfficerInfoBar from 'sharedComponents/LoanOfficerInfoBar';
import LoanTermsInfo from 'sharedComponents/LoanTermsInfo';

import useStyles from './useStyles';

const LoanOfficerPage = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bid, loanOfficer, onBack } = props;
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setActiveTabIndex(newValue);
  };

  const showLoanOfficerInfo = activeTabIndex === 0 && isPresent(loanOfficer);
  const showLoanOfficerPlaceHolder = activeTabIndex === 0 && isBlank(loanOfficer);
  const showBidInfo = activeTabIndex === 1 && isPresent(bid);
  const showBidPlaceHolder = activeTabIndex === 1 && isBlank(bid);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton onClick={onBack} className={classes.backButton}>
          <Icon name="backArrow" />
        </IconButton>
      </div>
      <Tabs
        value={activeTabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab label={t('components.LoanOfficerBar.officersInfo')} value={0} className={classes.tab} />
        <Tab label={t('components.LoanOfficerBar.loanTerms')} value={1} className={classes.tab} />
      </Tabs>
      <div className={classes.content}>
        {showLoanOfficerInfo && <LoanOfficerInfoBar loanOfficer={loanOfficer} />}
        {showLoanOfficerPlaceHolder && (
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanOfficerBar.LoanOfficerBlank')}
          </Typography>
        )}
        {showBidInfo && <LoanTermsInfo bid={bid} />}
        {showBidPlaceHolder && (
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanOfficerBar.bidIsBlank')}
          </Typography>
        )}
      </div>
    </div>
  );
};

LoanOfficerPage.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape(),
  bid: BidPresenter.shape(),
  onBack: PropTypes.func.isRequired,
};

LoanOfficerPage.defaultProps = {
  loanOfficer: {},
  bid: {},
};

export default LoanOfficerPage;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/LoanOfficerPage/LoanOfficerPage.js